import type { CSSProperties } from "react";
import "./workspace.css";
import { useGetIdentity } from "ra-core";
import { Link, useLocation } from "react-router";
import { effectiveRole, isFullAccessRole } from "../sales/roles";
import { routeGroup } from "./workspaceNavigation";
import { canAccess } from "../providers/commons/canAccess";
export function WorkspaceSections({ mobile = false }: { mobile?: boolean }) {
  const { identity } = useGetIdentity();
  const role = effectiveRole(identity);
  const { pathname } = useLocation();
  const group = routeGroup(pathname);
  let items: { to: string; label: string }[] = [];
  if (
    group === "counterparties" &&
    canAccess(role, { resource: "counterparties", action: "list" })
  )
    items = [
      { to: "/contacts", label: "Контакты" },
      { to: "/companies", label: "Компании" },
    ];
  if (
    (group === "management" || group === "projects") &&
    isFullAccessRole(role)
  )
    items = [
      { to: "/deals", label: "Сделки" },
      { to: "/work-projects", label: "Проекты в работе" },
      { to: "/analytics", label: "Аналитика" },
    ];
  items = items.filter((i) =>
    canAccess(role, {
      resource: i.to.slice(1).replace("work-projects", "work_projects"),
      action: "list",
    }),
  );
  // Detail cards use their own back navigation; the group switcher belongs to list pages.
  if (
    !identity ||
    items.length < 2 ||
    (mobile && pathname.split("/").filter(Boolean).length > 1)
  )
    return null;
  return (
    <nav
      aria-label="Раздел рабочей области"
      className={
        mobile
          ? "workspace-subnav fixed inset-x-0 top-14 z-20 border-b bg-background px-3 py-2"
          : "mb-5 flex justify-center"
      }
    >
      <div
        className={`rovero-segments ${mobile ? "w-full" : ""}`}
        style={{ "--segments": items.length } as CSSProperties}
      >
        <span
          aria-hidden="true"
          className="rovero-segment-indicator"
          style={{
            transform: `translateX(${
              Math.max(
                0,
                items.findIndex(
                  (i) => pathname === i.to || pathname.startsWith(i.to + "/"),
                ),
              ) * 100
            }%)`,
          }}
        />
        {items.map((i) => (
          <Link
            key={i.to}
            to={i.to}
            aria-current={
              pathname === i.to || pathname.startsWith(i.to + "/")
                ? "page"
                : undefined
            }
            className="rovero-segment focus-visible:outline-2 focus-visible:outline-ring"
            data-active={pathname === i.to || pathname.startsWith(i.to + "/")}
          >
            <span>
              {mobile && i.to === "/work-projects" ? "Проекты" : i.label}
            </span>
          </Link>
        ))}
      </div>
    </nav>
  );
}
